<template>
  <tbody>
    <template v-if="totalRows > 0">
      <tr v-for="row in rows" :key="`${metric}:${row.label}`">
        <td class="border px-4 py-2">
          {{ row.label }}
        </td>
        <td class="border px-4 py-2 text-right">
          {{ row.value.F || '' }}
        </td>
        <td class="border px-4 py-2 text-right">
          {{ row.value.M || '' }}
        </td>
        <td class="border px-4 py-2 text-right">
          {{ row.value.U || '' }}
        </td>
        <td class="border px-4 py-2 text-right font-bold">
          {{ calculateAgeRangeSum(row.value) }}
        </td>
      </tr>
      <tr>
        <td class="border px-4 py-2 font-bold">Total</td>
        <td class="border px-4 py-2 text-right font-bold">
          {{ calculateGenderSum('F') }}
        </td>
        <td class="border px-4 py-2 text-right font-bold">
          {{ calculateGenderSum('M') }}
        </td>
        <td class="border px-4 py-2 text-right font-bold">
          {{ calculateGenderSum('U') }}
        </td>
        <td class="border px-4 py-2 text-right font-bold">
          {{ calculateAgeRangeGenderSum() }}
        </td>
      </tr>
    </template>
    <template v-else>
      <tr>
        <td class="border px-4 py-2 text-teal-900 text-center" colspan="3">
          No insights available for {{ endTime }}
        </td>
      </tr>
    </template>
  </tbody>
</template>

<script>
import moment from 'moment';
import { sum, sumBy } from 'lodash-es';
// import { orderBy } from 'lodash-es';

export default {
  props: {
    metric: {
      type: String,
      required: true,
    },
    displayDate: Boolean,
    insights: {
      type: Object,
      required: true,
    },
  },
  computed: {
    endTime() {
      return moment(this.insights.end_time).format('DD/MM/YYYY');
    },
    rows() {
      const totalByGenderByAge = this?.insights?.value || {};

      return Object.values(
        Object.keys(totalByGenderByAge).reduce((totalByAgeByGender, current) => {
          const [gender, ageRange] = current.split('.');

          const oldValue = totalByAgeByGender?.[ageRange]?.value || { M: 0, F: 0, U: 0 };

          return {
            ...totalByAgeByGender,
            [ageRange]: {
              label: ageRange,
              value: {
                ...oldValue,
                [gender]: totalByGenderByAge[current],
              },
            },
          };
        }, {})
      );
    },
    totalRows() {
      return this.rows.length;
    },
  },
  methods: {
    calculateAgeRangeSum(values) {
      return sum(Object.values(values));
    },
    calculateGenderSum(gender) {
      return sumBy(this.rows, (o) => o.value[gender]);
    },
    calculateAgeRangeGenderSum() {
      return ['M', 'F', 'U'].reduce((carry, gender) => carry + this.calculateGenderSum(gender), 0);
    },
  },
};
</script>
